"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubMenuContainer = void 0;
var _uiKit = require("@icis/ui-kit");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
const {
  borderRadius,
  animation
} = _uiKit.theme;
const SubMenuContainer = exports.SubMenuContainer = _styledComponents.default.div.withConfig({
  displayName: "Wrapperstyle__SubMenuContainer",
  componentId: "sc-xh1czw-0"
})(["box-sizing:border-box !important;position:absolute;min-width:200px;z-index:8;", " transition:opacity ", ",border-color ", ",box-shadow ", ";border-radius:", ";", ""], props => {
  let topValue = "".concat(props.sY, "px");
  let positionValue = "left: ".concat(props.sX, "px;");
  if (props.positionToLeft && !props.clickableDropDown) {
    positionValue = "right: ".concat(props.sX, "px;");
  }
  if (props.positionToLeft && props.clickableDropDown) {
    topValue = "".concat(props.sY + 2, "px");
    positionValue = "right: ".concat(props.sX, "px;");
  }
  if (!props.showing) {
    topValue = "-10000px";
  }
  return "\n      top: ".concat(topValue, ";\n      ").concat(positionValue, "\n    ");
}, animation.DURATION, animation.DURATION, animation.DURATION, props => props.positionToLeft ? " ".concat(borderRadius.default, " 0 ").concat(borderRadius.default, " ").concat(borderRadius.default) : "0px ".concat(borderRadius.default, " ").concat(borderRadius.default, " ").concat(borderRadius.default), props => {
  if (props.showing) {
    return (0, _styledComponents.css)(["opacity:1;border:1px solid white;background-color:#ffffff;box-shadow:0 2px 4px 0 rgba(0,0,0,0.35);&:before{content:'';height:3px;width:", "px;position:absolute;top:-4px;background:inherit;z-index:9;", ";}"], props.parentWidth, props.positionToLeft ? 'right: -1px' : "left: ".concat(props.parentX || -1, "px"));
  }
  return "\n      opacity: 0;\n      border-color: transparent;\n      box-shadow: 0 0 0 0 transparent;\n    ";
});